import React from 'react';

import { Card, H2, Separator } from '@betterment/samba-react';

import { ClientAgreementsCardList } from './ClientAgreementsCardList';

export const ClientAgreementsCard: React.FC = () => {
  return (
    <Card>
      <Card.Header
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          px: 'space.300',
          py: 'space.200',
        }}
      >
        <H2 variant="title200">Client agreement</H2>
      </Card.Header>
      <Separator
        css={{
          fullWidthWithInset: 'space.200',
        }}
      />
      <Card.Header>
        <ClientAgreementsCardList />
      </Card.Header>
    </Card>
  );
};
